export default "__VITE_ASSET__a2007667__"